import { IconButton } from "@mui/material";

import { RobotoTooltip } from "@/shared/components/RobotoTooltip";
import { FilterListIcon } from "@/shared/foundation/icons/mui";

import type { FilterDisplayMode } from "../LogFilter";

import styles from "./FilterBar.module.css";

interface FilterDisplayModeToggleProps {
  mode: FilterDisplayMode;
  onToggle: () => void;
}

export function FilterDisplayModeToggle({
  mode,
  onToggle,
}: FilterDisplayModeToggleProps) {
  const isDim = mode === "dim";
  const title = isDim ? "Showing all rows" : "Hiding unmatched rows";

  return (
    <RobotoTooltip title={title}>
      <IconButton onClick={onToggle} aria-label={title} aria-pressed={isDim}>
        <FilterListIcon
          fontSize="inherit"
          className={isDim ? styles.dimModeIcon : undefined}
        />
      </IconButton>
    </RobotoTooltip>
  );
}
